var ua = navigator.userAgent;
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    isMobile = isIphone || isAndroid || ipad,
    href = window.location.href,
    hostArr = window.location.host.split(".");
hostArr[0] = "";
var host = hostArr.join(".");
var pathName = window.location.pathname;
var query = window.location.search;
var pathNameArr = ['/download', '/register', '/extensionPage']
// console.log(query)
console.log(process.env.NODE_ENV, 'process.env.NODE_ENV')
if (!isMobile) {
    const domain = process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'developer' ? 'https://dev.nova-x.ca' : window.location.origin.replace('app.', 'www.')
    if (pathNameArr.includes(pathName)) {
        window.location.href = `${domain}${pathName}${query}`
    } else {
        window.location.href = `${domain}`
    }
}

/*  if (href.indexOf("app.nova-x.ca") != -1) {
    if (pathName == "/download" || pathName == "/register" || pathName == "/extensionPage") {
      window.location.href = `https://dev.nova-x.ca${pathName}${query}`;
    } else {
      window.location.href = "https://dev.nova-x.ca";
    }
  } else {
    window.location.href = `https://www.superex.com/index/${getBrowserParams('language')}${query}`
    // if (pathName == "/download" || pathName == "/register") {
    //   window.location.href = `https://www.superex.com${pathName}/${getBrowserParams('language')}${query}`
    // } else {
    //   window.location.href = "https://www.superex.com";
    // }
}*/
function getBrowserParams(name) {
    const urlParams = new URLSearchParams(window.location.search);
    const language = urlParams.get(name);
    return language ? language : "";
}



// WEBPACK FOOTER //
// ./src/utils/isMobile.js